import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export class UpdateCurrentUserResponseModel extends BaseModel implements IRestModel {
    public response: boolean = null;
    public readonly isIRestModel = true;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'SHR-UpdateCurrentUserResponseModel', null, false);
    }

    public toRestApiModel() {
    }
}
